import React from "react";
import AddBookForm from "../components/Form/AddBookForm";
import Title from "../components/Title";

function AddBook(props) {
  return (
    <div className="w-full overflow-x-hidden">
      <div>
        <Title name="Add Book" />
      </div>
      <AddBookForm />
    </div>
  );
}

export default AddBook;
